export default "__VITE_ASSET__tkuKvMlv__"